export const LINK_TO_PDF = '/static/kbm-affilips-customer-information-letter.pdf'
export const LINK_TO_PRIVACY = '/static/privacybeleid.pdf'
export const LINK_TO_ROBA_METALS = 'https://www.robametals.com/'
export const LINK_TO_KBM_AFFILIPS = 'https://www.kbmaffilips.com'
